import { User } from "../types/user";

const getUserId = (user: User) => user?.id?.split("|")[1];
export default getUserId;
